import { render, staticRenderFns } from "./guessingGamePraizesRecord.vue?vue&type=template&id=4043393c&scoped=true"
import script from "./guessingGamePraizesRecord.vue?vue&type=script&lang=ts"
export * from "./guessingGamePraizesRecord.vue?vue&type=script&lang=ts"
import style0 from "./guessingGamePraizesRecord.vue?vue&type=style&index=0&id=4043393c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4043393c",
  null
  
)

export default component.exports